import {Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Stack} from "@mui/material";
import {useAccountOpt, useAccounts} from "../../pages/accounts/Accounts.tsx";
import {JSX, useMemo} from "react";
import {Add, Done as DoneIcon} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router-dom";
import {EventerConsoleNavigation} from "../../../EventerConsoleNavigation.tsx";

export default function AccountSwitch() {

    const {accounts} = useAccounts()
    const currentAccountOpt = useAccountOpt()

    const location = useLocation()
    const navigate = useNavigate()

    const accountElements = useMemo(() => {

        if (accounts == undefined || accounts.length === 0) {
            return []
        }

        let elements = [...accounts] // copy & sort
            .sort((a, b) => a.podName.localeCompare(b.podName))
            .map((account) => (
                <MenuItem
                    key={account.id}
                    component="button"
                    selected={account.id === currentAccountOpt?.id}
                    sx={{
                        // justifyContent: 'flex-start',
                        width: '100%',
                    }}
                    onClick={() => EventerConsoleNavigation.accounts.account(account.id).navigate(navigate, location)}
                >
                    {
                        account.id === currentAccountOpt?.id ? (
                            <ListItemIcon>
                                <DoneIcon/>
                            </ListItemIcon>
                        ) : null
                    }

                    <ListItemText
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            textAlign: 'right',
                            width: '100%',
                        }}
                        primary={account.podName}
                        slotProps={{
                            primary: {
                                variant: 'body1'
                            }
                        }}
                    />
                </MenuItem>
            ))

        elements.push(<Divider key="accounts-divider"/>)

        return elements
    }, [accounts])

    let addAccountEls: JSX.Element[] | undefined = undefined
    if (EventerConsoleNavigation.accounts.new.path !== location.pathname) {
        addAccountEls = [
            <MenuItem
                key="add-account"
                onClick={() => EventerConsoleNavigation.accounts.new.navigate(navigate, location)}
            >
                <ListItemIcon>
                    <Add/>
                </ListItemIcon>
                <ListItemText
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        textAlign: 'right',
                        width: '100%',
                    }}
                    primary="Pod erstellen"
                    slotProps={{
                        primary: {
                            variant: 'body1'
                        }
                    }}
                />
            </MenuItem>,
            <Divider key="add-account-divider"/>
        ]
    }

    return (
        <Stack direction="column">
            <MenuList dense>
                {accountElements}
                {addAccountEls}
            </MenuList>
        </Stack>
    );
}